import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

/** Tomorrow at nine, which is what most people want and nobody has to type. */
function defaultWhen() {
  const when = new Date()
  when.setDate(when.getDate() + 1)

  const month = `${when.getMonth() + 1}`.padStart(2, '0')
  const day = `${when.getDate()}`.padStart(2, '0')

  return { date: `${when.getFullYear()}-${month}-${day}`, time: '09:00' }
}

/**
 * Picks a wall-clock moment. No timezone control on purpose: the time is read in the business's
 * own zone, which is shown rather than chosen — a shop schedules in its own morning.
 */
export default function ScheduleDialog({ open, timezoneId, onCancel, onConfirm }) {
  const { t } = useTranslation()
  const [when, setWhen] = useState(defaultWhen)

  useEffect(() => {
    if (open) setWhen(defaultWhen())
  }, [open])

  if (!open) return null

  // Above the preview it was opened from — see ConfirmDialog for why this is not left to markup
  // order.
  return createPortal(
    <div className="overlay overlay--ask" role="presentation" onClick={onCancel}>
      <div
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-label={t('calendar.scheduleTitle')}
        onClick={(event) => event.stopPropagation()}
      >
        <h3>{t('calendar.scheduleTitle')}</h3>
        {timezoneId && <p className="muted small">{t('calendar.timezone', { zone: timezoneId })}</p>}

        <div className="form">
          <label>
            {t('calendar.date')}
            <input
              type="date"
              value={when.date}
              onChange={(event) => setWhen({ ...when, date: event.target.value })}
            />
          </label>

          <label>
            {t('calendar.time')}
            <input
              type="time"
              value={when.time}
              onChange={(event) => setWhen({ ...when, time: event.target.value })}
            />
          </label>
        </div>

        <div className="dialog__actions">
          <button type="button" className="button button--quiet" onClick={onCancel}>
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="button"
            disabled={!when.date || !when.time}
            onClick={() => onConfirm(`${when.date}T${when.time}`)}
          >
            {t('calendar.schedule')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
